import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Button from '@/app/_components/buttons/Button';

interface Props {
  step: string;
  data: string[];
  hasNext: boolean;
  onNext: () => void;
  hasSubmit?: boolean;
}
const OnboardingActivityType = ({
  step,
  data,
  hasSubmit,
  hasNext,
  onNext,
}: Props) => {
  const { register, control, watch } = useFormContext();

  const watchActivityType = watch('activity_types', false);

  if (step !== 'ACTIVITY_TYPE') {
    return null;
  }

  return (
    <div className="w-full md:w-[430px]">
      <label
        htmlFor="language"
        className="text-white font-hanken text-4xl font-extrabold mb-8 block"
      >
        <span className="text-purple3">Ok! </span>
        How do you plan on using ZocNotes?
      </label>
      <Controller
        name="activity_types"
        control={control}
        render={() => {
          return (
            <fieldset>
              {data?.map((activity: string, index: number) => {
                return (
                  <div className="inline-flex mr-4 mb-4" key={index}>
                    <input
                      type="checkbox"
                      value={activity}
                      {...register('activity_types')}
                      id={activity}
                      className="peer hidden"
                    />
                    <label
                      htmlFor={activity}
                      className="select-none cursor-pointer rounded-full py-3 px-6 text-white transition-colors bg-purple5 duration-200 ease-in-out peer-checked:bg-purple7"
                    >
                      {activity}
                    </label>
                  </div>
                );
              })}
            </fieldset>
          );
        }}
      />
      {hasNext && (
        <Button
          data-test-id="save-en-language"
          className="!rounded-full min-w-[200px] my-8"
          variant="primary"
          type="button"
          label="Next"
          disabled={!watchActivityType || watchActivityType.length <= 0}
          onClick={onNext}
        />
      )}
      {hasSubmit && (
        <div className="py-8">
          <Button
            data-test-id="onboarding-next"
            className="!rounded-full min-w-[200px]"
            variant="primary"
            type="submit"
            label={'Next'}
            onClick={onNext}
            disabled={!watchActivityType}
          />
        </div>
      )}
    </div>
  );
};

export default OnboardingActivityType;
